import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud-show',{attrs:{"title":"user.apikeyTitle","open":_vm.open},on:{"close":function($event){return _vm.$emit('close')}}},[(_vm.apikey === null)?_c(VBtn,{attrs:{"loading":_vm.loading,"outlined":"","color":"blue"},on:{"click":_vm.getApikey}},[_vm._v(" "+_vm._s(_vm.$t('user.getApikey'))+" ")]):_c('span',[_vm._v(_vm._s(_vm.apikey))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }